import React from 'react';
import { Button, MenuItem, TextField as MUITextField } from '@material-ui/core';

class DevToolbox extends React.Component {
  render() {
    const { state, setState, jumpTo, reset, preprocessformdata } = this.props;

    const parseForClipboard = () => {
      var formdata = JSON.stringify(preprocessformdata());

      const regex = /"contents":\s*"[^"]+?([^/"]+)"/gm;

      return formdata.replaceAll(regex, '"contents": "redacted"');
    };

    return (
      <div id="devToolbox">
        <Button variant="contained" color="primary" onClick={() => reset()}>
          Reset
        </Button>
        <Button variant="contained" color="primary" onClick={() => jumpTo('intro')}>
          Go Home
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigator.clipboard.writeText(parseForClipboard())}>
          Copy Form Data
        </Button>
        <MUITextField
          label="Goto step"
          select
          value={state.stepIds.length > 0 && state.toStep ? state.toStep : ''}
          onChange={(e) => {
            setState({ toStep: e.target.value });
            jumpTo(e.target.value);
          }}>
          {state.stepIds.map((id) => (
            <MenuItem key={id} value={id}>
              {id}
            </MenuItem>
          ))}
        </MUITextField>
        <MUITextField
          label="Sample Data"
          select
          value={state.sampledata ? state.sampledata : ''}
          onChange={(e) => {
            setState({ sampledata: e.target.value });
          }}>
          <MenuItem value="JNKAY01E76M111720">VIN</MenuItem>
          <MenuItem value="99000000000">ABN</MenuItem>
          <MenuItem value="143526096">ACN</MenuItem>
          <MenuItem value="123456782">TFN</MenuItem>
          <MenuItem value="2428778132">Medicare</MenuItem>
        </MUITextField>
        <span>{state.sampledata}</span>
      </div>
    );
  }
}

export default DevToolbox;
